import { Typography } from '@bgzt/ui';
import { Section } from '~/components';
import { AUTHORIZED_SHOPS } from '~/constants';

import styles from './Footer.module.css';

type Props = {
  shopId?: string;
};
export const Footer = ({ shopId }: Props) => {
  const getSellerDescription = () => {
    switch (shopId) {
      case AUTHORIZED_SHOPS.mandarake.id:
        return '본 상품은 만다라케(mandarake) 상품으로';
      default:
        return '본 메루카리 상품은 일본 내 개인 판매자 상품으로';
    }
  };
  return (
    <footer>
      <Section className={styles.container}>
        <Typography variant="C8" color="gray-400">
          {`${getSellerDescription()}, 번개장터의 제휴사가 상품 구매와 배송을 대행해요.`}
        </Typography>
      </Section>
    </footer>
  );
};
